// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d9e6aaa4","787":"352e413c"}[chunkId] + ".chunk.js";
};